// extracted by mini-css-extract-plugin
export default {"wrapper":"CommonCard_wrapper__3w9QK"};